import React, {useRef} from 'react';

function Editor(props)  {

  const editorRef = useRef(null);


  const makeBold = (e) => {
    e.preventDefault();
    document.execCommand('bold', false, null);
  };

  const makeItalic = (e) => {
    e.preventDefault();
    document.execCommand('italic', false, null);
  };

  const insertImage = (e) => {
    e.preventDefault();
    const imageUrl = prompt('Enter the image URL:');
    if (imageUrl) {
      const imgTag = `<img src="${imageUrl}" alt="Inserted Image">`;
      document.execCommand('insertHTML', false, imgTag);
    }
  };

  const insertLink = (e) => {
    e.preventDefault();
    const url = prompt('Enter the link URL:');
    if (url) {
      document.execCommand('createLink', false, url);
    }
  };

  const removeLink = (e) => {
    e.preventDefault();
    document.execCommand('unlink', false, null);
  };


  return (<div className="obj-377">
    <>
      <button onClick={makeBold}>Bold</button>
      <button onClick={makeItalic}>Italic</button>
      <button onClick={insertImage}>Insert Image</button>
      <button onClick={insertLink}>Insert Link</button>
      <button onClick={removeLink}>Remove Link</button>
    </>
    <div
      ref={editorRef}
      contentEditable
      style={{border: '1px solid #ccc', padding: '10px'}}
      dangerouslySetInnerHTML={{__html: 'Select some <i>text</i> and use the buttons to format it or click "Insert Image" or "Insert Link" to add an image or link.'}}
    />
  </div>);
};

export default Editor;


